import axios from "axios";

import { host } from './config';

function getTenantIdentifier() {
  const full = window.location.host;
  // window.location.host is subdomain.domain.com
  const parts = full.split('.');
  switch (parts.length) {
    case 3:
      return parts[0];
    case 1:
      if (parts[0].startsWith('localhost')) {
        return 'localhost';
      }
      break;
    default:
      return 'localhost';
  }
  return null;
}

const request = (url, options) => {
  return async () => {
    const OPTIONS = options;

    if (url === '/login') {
      OPTIONS.data = {
        ...OPTIONS.data,
        tenant: getTenantIdentifier(),
      };
    }
    const URL = host + '/api' + url;

    const userToken = localStorage.getItem('userToken');
    let config = {};
    if (userToken !== 'undefined') {
      const tokenHeader = {
        headers: { Authorization: userToken },
      };
      config = {
        url: URL,
        ...tokenHeader,
        ...OPTIONS,
      };
    } else {
      config = {
        url: URL,
        ...OPTIONS,
      };
    }

    let response;
    try {
      response = axios.request(config);
      // eslint-disable-next-line no-console
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
    return response;
  };
};

export default request;
